import { Navigate, useLocation } from "react-router-dom";

/**
 * A route alias that keeps the query and the hash. `<Navigate to="/auth/login">`
 * on `/login` used to drop both — and with them the login deep link (`?next=`)
 * the error screen's "log in again" and older links send along (billing-comms
 * Teil 2a). Nothing is validated here: whoever READS `next` runs it through
 * `safeNext`.
 */
export function RedirectKeepingQuery({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}
